import { useEffect, useState } from "react";

/**
 * @param {string} query - ex.: "(max-width: 768px)"
 * @param {boolean} [defaultValue=false]
 */
export function useMediaQuery(query, defaultValue = false) {
  const getMatches = () => {
    if (typeof window === "undefined" || !window.matchMedia) return defaultValue;
    return window.matchMedia(query).matches;
  };

  const [matches, setMatches] = useState(getMatches);

  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia) return undefined;

    const media = window.matchMedia(query);
    const onChange = (event) => setMatches(event.matches);

    setMatches(media.matches);
    if (typeof media.addEventListener === "function") {
      media.addEventListener("change", onChange);
      return () => media.removeEventListener("change", onChange);
    }

    media.addListener(onChange);
    return () => media.removeListener(onChange);
  }, [query]);

  return matches;
}

export const useIsMobile = () => useMediaQuery("(max-width: 768px)");

export const useIsNarrow = () => useMediaQuery("(max-width: 480px)");
